// @ts-check
import React from 'react';

import AppConfig from '../../appConfig';
import BusComponent from '../BusComponent';
import MapLayersPanel from './MapLayersPanel';
import { BASE_MAP_THUMBNAIL } from '../../enums/BaseMapTypes';
import { injectIntl } from 'react-intl';

/**
 * @typedef Props
 * @property {import('../../objects/MapInstance').default} mapInstance
 * @property {import('../MapViewer').default} mapViewer
 * @property {function} onShowDataBrowser
 * @property {string} tourId
 * @property {object} currentUser
 * @property {boolean} isVisible
 * @property {number} mapInstanceIndex
 * @property {import('react-intl').intlShape} intl
 * @property {object[]} visualReports
 *
 * @typedef State
 * @property {string} mode
 * @property {string} previouslySelectedMode
 * @property {boolean} isMapLayersPanelVisible
 *
 * @extends BusComponent<Props, State>
 */
class MapLayersPanelContainer extends BusComponent {
    constructor(props, context) {
        super(props, context);
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    handleClose = () => {
        this.emit('TOGGLE_MAP_LAYERS_PANEL', { isVisible: false, source: 'user' });
    };

    handleShowBtnClick = () => {
        this.emit('TOGGLE_MAP_LAYERS_PANEL', { isVisible: true, source: 'user' });
    };

    render() {
        const {
            isVisible,
            mapInstance,
            mapInstanceIndex,
            currentUser,
            mapViewer,
            onShowDataBrowser,
            visualReports,
            tourId,
            intl,
        } = this.props;

        const thumbnail = BASE_MAP_THUMBNAIL[mapInstance.activeBaseMap];
        const layersButton = (
            <div className="map-layers-panel__container">
                <button
                    className="show-btn"
                    style={{
                        backgroundImage:
                            `linear-gradient(rgba(0, 0, 0, 0.28), rgba(0, 0, 0, 0.28)), ` +
                            `url('${AppConfig.constants.assetsBaseURL}/icons/${thumbnail}')`,
                    }}
                    onClick={this.handleShowBtnClick}
                    data-testid="map-layers-open"
                >
                    <i className="material-icons-outlined">layers</i>
                    <span>{intl.formatMessage({ id: 'map.layers' })}</span>
                </button>
            </div>
        );

        return !isVisible ? (
            layersButton
        ) : (
            <MapLayersPanel
                mapInstance={mapInstance}
                mapInstanceIndex={mapInstanceIndex}
                currentUser={currentUser}
                onShowDataBrowser={onShowDataBrowser}
                mapViewer={mapViewer}
                tourId={tourId}
                onClose={this.handleClose}
                visualReports={visualReports}
            />
        );
    }
}

export default injectIntl(MapLayersPanelContainer);
